import { AddressValidationError } from 'utils/AddressValidationError';

import { GoogleAddressAPIResponse } from './types';

export const validateResponse = (response: GoogleAddressAPIResponse): void => {
  if ('error' in response || !('result' in response)) {
    throw new AddressValidationError(
      "There's been an error trying to verify the address, please try again"
    );
  }
  if (
    !response?.result?.verdict.addressComplete ||
    response?.result?.verdict.hasUnconfirmedComponents
  ) {
    throw new AddressValidationError('Cannot reliably verify the address');
  }

  const everyComponentIsConfirmed = response?.result?.address?.addressComponents?.every(
    (component) => component.confirmationLevel === 'CONFIRMED'
  );

  if (!everyComponentIsConfirmed) {
    throw new AddressValidationError('Cannot reliably verify the address');
  }
};
